import React from 'react';
import './VersionNum.scss';

import packagejson from "../../../package.json"

const VersionNum = ({ className = 'version-num' }) => {
    return <p className={className}>v{packagejson.version}</p>;
}

export default VersionNum;